import { CustomerRemoteInfo, GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

interface AuthBySmsCodeData {
  authBySmsCode: CustomerRemoteInfo
}

interface AuthBySmsCodeVariables {
  id: GQL_ID
  smsCode: string
}

export const GQL_MUTATION_AUTH_BY_SMS_CODE = gql`
  mutation AuthBySmsCode($id: ID!, $smsCode: String!) {
    authBySmsCode(id: $id, smsCode: $smsCode) {
      id
      phone
      first_name
      last_name
      receipt_email
      status
      new_phone
      email
      new_email
      isEmailVerified
      secondsBeforeDeletion
      requireRegistration
      authTokens {
        token
        refreshToken
      }
    }
  }
`

export const useAuthBySmsCode = () =>
  useMutation<AuthBySmsCodeData, AuthBySmsCodeVariables>(GQL_MUTATION_AUTH_BY_SMS_CODE)
